import { render, staticRenderFns } from "./createProductsFirst.vue?vue&type=template&id=a883e496&scoped=true"
import script from "./createProductsFirst.vue?vue&type=script&lang=js"
export * from "./createProductsFirst.vue?vue&type=script&lang=js"
import style0 from "./createProductsFirst.vue?vue&type=style&index=0&id=a883e496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a883e496",
  null
  
)

export default component.exports